
/**
 * author: Ananthapadmanabhan V K
 */
 

export const ACCEPT_INVITE_TXT = 'ACCEPT_INVITE';
export const COMPLETED_TXT = 'COMPLETED';
export const PASSWORD_SET_TXT = 'PASSWORD_SET';
export const ONBOARD_TXT = 'ONBOARD';
export const PENDING_INVITATION_TXT = 'PENDING_INVITATION';
export const SUPPLIER_DETAILS_TXT = 'SUPPLIER_DETAILS';
const CommonService = {
    checkValidValue(data) {
        if(data !=null && data!==undefined && data!=='') {
            return true;
        } else if(typeof data === 'object' ||  !Array.isArray(data)) {
            console.log('2',typeof data === 'object',!Array.isArray(data))
            return true;
        } else {
            return false;
        }
    },

    // Update according to i18n
    changeFieldNameByi18n(grpData,language) {
        const updatedData = grpData.map(item => {
            if (item.localizedContents && item.localizedContents.length > 0) {
              const translated = item.localizedContents.find(
                content => content.languageCode == language
              );
              if (translated) {
                return { ...item, name: translated.translatedValue };
              }
            }
            return item;
          });  

          return updatedData;
    }
};
export default CommonService;